"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toSnackbarIsOpen = void 0;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var toSnackbarIsOpen = function (milliSec) { return function (source$) {
    return source$.pipe((0, operators_1.switchMapTo)((0, rxjs_1.timer)(milliSec).pipe((0, operators_1.mapTo)(false), (0, operators_1.startWith)(true))));
}; };
exports.toSnackbarIsOpen = toSnackbarIsOpen;
